"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _graphql = require("../generated/graphql");
var _BookButton = _interopRequireDefault(require("./designsystem/BookButton"));
var _Stack = _interopRequireDefault(require("./Stack"));
var _grid = require("@rebass/grid");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var __jsx = _react.default.createElement;
const ActivityBookButton = ({
  bookingType,
  externalBookingUrl,
  selectedDayIsBookable,
  ticketText,
  onPlannerModalOpen,
  onBuyTickets
}) => __jsx(_grid.Flex, {
  ml: [null, null, 'auto'],
  width: [1, null, 'auto'],
  alignItems: "center"
}, bookingType === _graphql.ActivityBookingTypesEnum.Direct && !selectedDayIsBookable && !ticketText && __jsx(_react.default.Fragment, null, __jsx(_BookButton.default, {
  style: {
    marginLeft: 'auto'
  },
  onClick: onPlannerModalOpen
}, __jsx(_reactIntl.FormattedMessage, {
  id: "Y7YWvc",
  defaultMessage: [{
    "type": 0,
    "value": "Bekijk tijden"
  }]
}))), bookingType === _graphql.ActivityBookingTypesEnum.External && __jsx(_BookButton.default, {
  onClick: onPlannerModalOpen,
  target: "_blank"
}, __jsx(_reactIntl.FormattedMessage, {
  id: "Y7YWvc",
  defaultMessage: [{
    "type": 0,
    "value": "Bekijk tijden"
  }]
})), bookingType === _graphql.ActivityBookingTypesEnum.Direct && (selectedDayIsBookable || ticketText) && !externalBookingUrl && __jsx(_Stack.default, {
  width: 1,
  alignItems: "center",
  variant: "inline",
  spacing: 3,
  justifyContent: ['space-between']
}, __jsx(_react.default.Fragment, null, ticketText && __jsx(_Body.default, {
  variant: "small"
}, ticketText), __jsx(_BookButton.default, {
  onClick: ticketText ? onBuyTickets : onPlannerModalOpen
}, __jsx(_reactIntl.FormattedMessage, {
  id: "Y7YWvc",
  defaultMessage: [{
    "type": 0,
    "value": "Bekijk tijden"
  }]
})))));
var _default = exports.default = ActivityBookButton;